<template>
  <sign-page
    title-text="活动类型"
    :request="request"
    table-size="large"
    ref="activityTypePage"
    :titleMenus="[{key: 'new', label: '新增'}]"
    :tableActions="[{key: 'update', label: '修改'}, {key: 'deleter', label: '删除'}]"
    @clickTitleMenu="clickTitleMenu"
    @tableAction="tableAction"
    :column-list="columnList"
    :table-actions-fixed="true"
    :tableActionsWidth="100">
    <type-form ref="typeForm" :data="chooseData" @dataUpdate="dataUpdate"></type-form>
  </sign-page>
</template>

<script>
import TypeForm from './cmp/typeForm'

import {
  activityTypeRequest as request
} from '../../api'

export default {
  components: {
    TypeForm
  },
  computed: {
    columnList () {
      return [{
        field: 'name',
        title: '类型名称'
      },
      {
        field: 'keyLabel',
        title: '字段'
      }]
    }
  },
  data () {
    return {
      chooseData: {},
      request: Object.assign({}, request, {
        get: this.loadData
      })
    }
  },
  methods: {
    dataUpdate () {
      this.$refs.activityTypePage.loadData()
    },
    async tableAction (p) {
      this.chooseData = p.data
      if (p.action === 'update') {
        this.$refs.typeForm.open()
      } else if (p.action === 'deleter') {
        if (this.chooseData.activityNum) {
          this.$notify({
            title: '系统提示',
            message: '该类型已存在活动无法删除，请先删除活动后重试！',
            type: 'info'
          })
          return
        }
        const result = await this.$dialog.confirm({title: '系统提示', content: '确定删除该活动类型吗?'})
        if (result) {
          await request.del(this.chooseData.id)
          this.$refs.activityTypePage.loadData()
        }
      }
    },
    async loadData (parm) {
      let datas = await request.get(parm)
      datas.forEach(v => {
        v.keyList = v.config ? JSON.parse(v.config) : []
        v.keyLabel = v.keyList.map(v1 => v1.key).join(',')
      })
      return datas
    },
    clickTitleMenu (p) {
      if (p === 'new') {
        this.$refs.typeForm.open()
      }
    }
  }
}
</script>
